import { useCallback, useEffect, useState } from "react";
import { adminAuthService } from "../services/adminAuthService";

export interface UseAdminAuthReturn {
  isAdminLoggedIn: boolean;
  adminToken: string | null;
  adminLogin: (token: string) => void;
  adminLogout: () => void;
  checkAdminAuth: () => boolean;
}

export const useAdminAuth = (): UseAdminAuthReturn => {
  const [adminToken, setAdminToken] = useState<string | null>(null);
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);

  // 컴포넌트 마운트 시 로컬 스토리지에서 관리자 토큰 확인
  useEffect(() => {
    const token = localStorage.getItem("adminAccessToken");
    if (token) {
      setAdminToken(token);
      setIsAdminLoggedIn(true);
    }
  }, []);

  // 관리자 로그인
  const adminLogin = useCallback((token: string) => {
    localStorage.setItem("adminAccessToken", token);
    setAdminToken(token);
    setIsAdminLoggedIn(true);
  }, []);

  // 관리자 로그아웃
  const adminLogout = useCallback(() => {
    adminAuthService.logout();
    setAdminToken(null);
    setIsAdminLoggedIn(false);
  }, []);

  // 관리자 인증 상태 확인
  const checkAdminAuth = useCallback((): boolean => {
    const token = localStorage.getItem("adminAccessToken");
    return Boolean(token);
  }, []);

  return {
    isAdminLoggedIn,
    adminToken,
    adminLogin,
    adminLogout,
    checkAdminAuth,
  };
};
